/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Indicates which type of filter UI to use.
 */
export var FilterUIType = /*@__PURE__*/ (function (FilterUIType) {
    /**
     * Filtering is displayed within the column options menu.
     */
    FilterUIType[FilterUIType["ColumnOptions"] = 0] = "ColumnOptions";
    /**
     * A filter row is displayed. Each filter cell in the row will let you select filter operator as well as filter
     * condition for the associated field.
     */
    FilterUIType[FilterUIType["FilterRow"] = 1] = "FilterRow";
    /**
     * No filter UI is used.
     */
    FilterUIType[FilterUIType["None"] = 2] = "None";
    return FilterUIType;
})({});
/**
 * @hidden
 */
export var FilterUIType_$type = /*@__PURE__*/ markEnum('FilterUIType', 'ColumnOptions,0|FilterRow,1|None,2');
//# sourceMappingURL=FilterUIType.js.map
